import RmnBannerContent from 'components/Content/RmnBannerContent/RmnBannerContent';

export default RmnBannerContent;
